module.exports = __webpack_public_path__ + "img/cancelLine.41d53f81.png";